export const initialState = {
    filter: {
        createdAtStartDate: null,
        createdAtEndDate: null,
        nameKeyword: null,
        status: null,  
        page: null,
        size: null,
    },
    isFilter: false,
    typeAction: null
  };
  
  const questionarySearchReducer = (state = initialState, action) => {
    switch (action.type) {
      case "SET_FILTER_QUESTIONARY":
        return {
          ...state,
          filter: action.filter,
          isFilter: action.isFilter,
          typeAction: action.typeAction
        };
      default:
        return state;
    }
  };
  
  export default questionarySearchReducer;
  